interface SubscribePayload {
  email: string;
  firstname: string;
}

export const subscribeToNewsletter = async (data: SubscribePayload) => {
  const BREVO_API_KEY = import.meta.env.VITE_BREVO_API_KEY;
  const LIST_ID = parseInt(import.meta.env.VITE_BREVO_LIST_ID || '0', 10);
  
  if (!LIST_ID) {
    throw new Error('Brevo list ID is not configured');
  }

  try {
    console.log('Sending request to Brevo with data:', {
      email: data.email,
      attributes: { FIRSTNAME: data.firstname },
      listIds: [LIST_ID]
    });

    const response = await fetch('https://api.sendinblue.com/v3/contacts', {
      method: 'POST',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'api-key': BREVO_API_KEY
      },
      body: JSON.stringify({
        email: data.email,
        attributes: {
          FIRSTNAME: data.firstname
        },
        listIds: [LIST_ID],
        updateEnabled: true
      })
    });

    const responseText = await response.text();
    console.log('Brevo API response:', {
      status: response.status,
      statusText: response.statusText,
      headers: Object.fromEntries(response.headers.entries()),
      body: responseText
    });
    
    if (!response.ok) {
      let errorMessage;
      try {
        const errorData = responseText ? JSON.parse(responseText) : {};
        errorMessage = errorData.message || 'Failed to subscribe';
        console.error('Brevo API error:', errorData);
      } catch {
        errorMessage = 'Failed to subscribe to newsletter';
        console.error('Failed to parse error response:', responseText);
      }
      throw new Error(errorMessage);
    }

    // Return success even if response is empty
    return responseText ? JSON.parse(responseText) : { success: true };
  } catch (error) {
    console.error('Newsletter subscription error:', error);
    throw new Error(error instanceof Error ? error.message : 'Failed to subscribe to newsletter');
  }
};
